import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2db8ee7c&scoped=true&functional=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=2db8ee7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "2db8ee7c",
  null
  
)

export default component.exports